import gql from 'graphql-tag';

export const GET_STATUSES = gql`
  query {
    allRentalItemStatuses {
      id
      status
    }
  }
`;

export const GET_TYPES = gql`
  query {
    allRentalItemTypes {
      id
      type
    }
  }
`;

export const GET_RENTAL_ITEMS_TITLES = gql`
  query GetRentalItemsTitles($businessOwnerId: Int!) {
    rentalItemsTitles(businessOwnerId: $businessOwnerId) {
      id
      title
      titleNo
    }
  }
`;

export const RENTAL_ITEMS = gql`
  query rentalItems($page: Int, $businessOwnerId: Int) {
    rentalItems(
      page: $page
      numberOfRentalItemsPerPage: 11
      businessOwnerId: $businessOwnerId
    ) {
      id
      photo
      title
      productCode
      itemsType {
        id
        type
      }
      status {
        id
        status
      }
      availableUnits
    }
    numberOfRentalItemsPages(
      numberOfRentalItemsPerPage: 11
      businessOwnerId: $businessOwnerId
    )

    rentalItemsOverview(businessOwnerId: $businessOwnerId) {
      rentalItems {
        total
        available
        expired
      }
    }
  }
`;

export const RENTAL_ITEM = gql`
query rentalItems($rentalItemsId: Int,, $businessOwnerId: Int) {
    rentalItems(
      rentalItemsId: $rentalItemsId
      businessOwnerId: $businessOwnerId
    ) {
      id
      photo
      title
      titleNo
      productCode
      itemsType {
        id
        type
      }
      status {
        id
        status
      }
      availableUnits
      minDays
      maxDays

      description
      descriptionNo
      cancellation
      cancellationNo
      included
      includedNo
      notIncluded
      notIncludedNo

      pricesType

      prices {
        id
        currency {
          currency
        }
        value
        day {
          id
          name
        }
        type
      }
      hourlyPrices {
        id
        currency {
          currency
        }
        value
        hour {
          id
          hour
          displayHour
        }
      }
      masterMinMaxHours {
        minHours
        maxHours
      }
      rentedOutDates {
        id
        startDate
        endDate
        numberOfUnits
      }
      
      addOns {
        id
        title
        titleNo
        description
        descriptionNo
        photo
        prices {
          currency {
            currency
          }
          value
        }
      }
    }
  }
`;

export const RENTAL_ITEMS_AVAILABLE_UNITS = gql`
  query GetRentalItemsWithUnits(
  $rentalItemsId: Int
  $businessOwnerId: Int
  $startPeriod: Date!
  $endPeriod: Date!
  $startTime: DateTime
  $endTime: DateTime
) {
  rentalItems(
    rentalItemsId: $rentalItemsId
    businessOwnerId: $businessOwnerId
    startPeriod: $startPeriod
    endPeriod: $endPeriod
  ) {
    id
    pricesType

    availableUnitsPerDate(
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      startTime: $startTime
      endTime: $endTime
    ) {
      date
      availableUnits
      startTime
      endTime
    }
  }
}
`;

export const WIDGET_RENTAL_ITEMS = gql`
  query rentalItems(
    $page: Int
    $businessOwnerId: Int
    $numberOfRentalItemsPerPage: Int!
    $startPeriod: Date
    $endPeriod: Date
    $unitsNumber: Int
  ) {
    rentalItems(
      page: $page
      businessOwnerId: $businessOwnerId
      numberOfRentalItemsPerPage: $numberOfRentalItemsPerPage
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      unitsNumber: $unitsNumber
    ) {
      id
      photo
      title
      titleNo
      status {
        id
        status
      }

      description
      descriptionNo
      cancellation
      cancellationNo
      included
      includedNo
      notIncluded
      notIncludedNo
      
      availableUnits
      pricesType
      prices {
        id
        currency {
          currency
        }
        value
        day {
          id
          name
        }
        type
      }
      hourlyPrices {
        id
        currency {
          currency
        }
        value
        hour {
          id
          hour
          displayHour
        }
      }
    }
    numberOfRentalItemsPages(
      businessOwnerId: $businessOwnerId
      numberOfRentalItemsPerPage: $numberOfRentalItemsPerPage
    )
  }
`;